import { render } from "./CalendarComponent.vue?vue&type=template&id=d8608dc2&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=d8608dc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8608dc2"]])

export default __exports__